import React, { useEffect, useState } from "react"
import { Alert, Spin, Tag, Timeline } from "antd"
import StickyTable from "../../components/table/StickyTable"   // tog'a #4695/#4703: hamma jadvalda sarlavha va «Итого» qotadi
import i18n from "../../services/i18n"
import { GET_TRANSFER_HISTORY } from "./mutations"
import { apiErrorText } from "../../utils/apiError"
import { useIsMainSystem } from "../../utils/mainSystem"   // tog'a #4104

// tog'a #2455 (2026-09-24): perevod TARIXI — hujjat (TR-raqam), tovarlar va jurnal: kim, qachon, nima, qancha, sabab.
// Jurnal yuritilmagan davrdagi perevodlar tarixi server tomonda maydonlardan tiklanadi («restored» belgisi bilan).
const EV: Record<string, { color: string; label: string }> = {
  created: { color: "blue", label: i18n.t("trEvCreated", "Создано") },
  sent: { color: "cyan", label: i18n.t("trEvSent", "Отправлено") },
  accepted: { color: "green", label: i18n.t("trEvAccepted", "Принято") },
  partial: { color: "orange", label: i18n.t("trEvPartial", "Принято с недостачей") },
  rejected: { color: "red", label: i18n.t("trEvRejected", "Отклонено получателем") },
  cancelled: { color: "gray", label: i18n.t("trEvCancelled", "Отменено") },
  // tog'a #3177 (2026-10-02): «Ожидание»dagi perevod tahriri
  edited: { color: "purple", label: i18n.t("trEvEdited", "Изменено") },
  added: { color: "geekblue", label: i18n.t("trEvAdded", "Добавлено") },
  removed: { color: "volcano", label: i18n.t("trEvRemoved", "Убрано") },
}
const STATUS: Record<number, string> = {
  0: i18n.t("awaitingStatus"),
  1: i18n.t("inTransitStatus"),
  2: i18n.t("deliveredStatusM"),
  3: i18n.t("cancelled"),
}

export default function TransferHistory({ id }: { id: number }) {
  const bm = useIsMainSystem()   // tog'a #4104: hamkor tizimida partiya ustuni yo'q
  const [data, setData] = useState<any>(null)
  const [err, setErr] = useState("")
  useEffect(() => {
    GET_TRANSFER_HISTORY(id)
      .then(setData)
      .catch((e: any) => setErr(apiErrorText(e)))
  }, [id])
  if (err) return <Alert type="error" showIcon message={err} />
  if (!data) return <div style={{ textAlign: "center", padding: 24 }}><Spin /></div>

  // Bir xil hodisa (tur, xodim, daqiqa, sabab) — bitta satr: ko'p tovarli hujjat bitta «Создано» bo'lib ko'rinadi
  const guruh: any[] = []
  for (const e of data.events || []) {
    const k = [e.event, e.userName || "", String(e.at || "").slice(0, 16), e.note || ""].join("|")
    const g = guruh.find((x) => x.k === k)
    if (g) g.items.push(e)
    else guruh.push({ ...e, k, items: [e] })
  }
  const vaqt = (d: string) => new Date(d).toLocaleString("ru", { dateStyle: "short", timeStyle: "short" })

  return (
    <div data-testid="transfer-history">
      <div style={{ marginBottom: 10, fontSize: 14 }}>
        <b>{data.transferNumber}</b> · {data.from} → {data.to}
        {data.note ? <span style={{ color: "#64748b" }}> · {data.note}</span> : null}
      </div>
      <StickyTable
        size="small"
        rowKey="id"
        pagination={false}
        scroll={{ x: "max-content" }}
        dataSource={data.items || []}
        style={{ marginBottom: 16 }}
        columns={[
          { title: i18n.t("product"), dataIndex: "product", render: (v: string) => <b>{v}</b> },
          { title: i18n.t("barCode"), dataIndex: "barCode", render: (v: string) => v || "—" },
          { title: i18n.t("article"), dataIndex: "article", render: (v: string) => v || "—" },
          ...(bm ? [{ title: i18n.t("numberParty"), dataIndex: "batchNumber", render: (v: string) => v || "—" }] : []),   // tog'a #4104: faqat glavniy tizimda
          { title: i18n.t("trSent", "Отправлено"), dataIndex: "sent", align: "right" as const, render: (v: any) => v == null ? <Tag color="purple">🙈 {i18n.t("trQtyHidden", "скрыто")}</Tag> : v },   // tog'a #3248
          // tog'a #2888: perevod narxi va summasi (eski perevodda narx yo'q — «—»)
          { title: i18n.t("trTransferPrice"), dataIndex: "transferPriceUSD", align: "right" as const, render: (v: number, r: any) => { const n = v ?? r.salePriceUSD; return n == null ? "—" : `$${n}` } },
          { title: i18n.t("trSum"), key: "sum", align: "right" as const, render: (_: any, r: any) => { const n = r.transferPriceUSD ?? r.salePriceUSD; return n == null || r.sent == null ? "—" : <b>${Math.round(n * (Number(r.sent) || 0) * 100) / 100}</b> } },
          {
            title: i18n.t("trAccepted", "Принято"), dataIndex: "accepted", align: "right" as const,
            render: (v: number, r: any) => v == null ? "—" : <span style={{ color: v < r.sent ? "#c2410c" : undefined, fontWeight: 600 }}>{v}</span>,
          },
          { title: i18n.t("status"), dataIndex: "status", render: (s: number) => <Tag>{STATUS[s] || s}</Tag> },
        ]}
      />
      <Timeline>
        {guruh.map((g) => {
          const m = EV[g.event] || { color: "gray", label: g.event }
          return (
            <Timeline.Item key={g.k} color={m.color}>
              <b>{m.label}</b> · {vaqt(g.at)} · {g.userName || "—"}
              <div style={{ fontSize: 12, color: "#64748b" }}>
                {g.items.map((x: any) => `${x.product}: ${x.count ?? "—"}`).join("; ")}
              </div>
              {g.note ? <div style={{ fontSize: 12, color: "#b45309" }}>{g.note}</div> : null}
              {g.restored ? (
                <div style={{ fontSize: 11, color: "#94a3b8" }}>
                  {i18n.t("trEvRestored", "восстановлено по данным перемещения — журнал тогда ещё не вёлся")}
                </div>
              ) : null}
            </Timeline.Item>
          )
        })}
      </Timeline>
    </div>
  )
}
